import React from "react";
import Slider from "react-slick";
import mobileScreen1 from "../../../assets/Images/mobileScreen1.png";
import mobileScreen2 from "../../../assets/Images/mobileScreen2.png";
import mobileScreen3 from "../../../assets/Images/mobileScreen3.png";
import rightArrow from "../../../assets/Images/rightArrow.svg";
import leftArrow from "../../../assets/Images/leftArrow.svg";


const APP_SCREENS = [
  {
    screenImg: mobileScreen1,
    text: "Branded App On Playstore",
  },
  {
    screenImg: mobileScreen3,
    text: "Your Home Page",
  },
  {
    screenImg: mobileScreen2,
    text: "Your Courses",
  },
];

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        top: "45%",
        zIndex: 2,
      }}
      onClick={() => onClick()}
    >
      <img src={leftArrow} />
    </div>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      style={{
        position: "absolute",
        top: "45%",
        right: "0px",
      }}
      onClick={() => onClick()}
    >
      <img src={rightArrow} />
    </div>
  );
}

const Carousel = ({ isMobile }) => {
  const slider = React.useRef(null);
  // isMobile = true;
  const settings = {
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    cssEase: "linear",
    pauseOnHover: true,
    nextArrow: isMobile && <NextArrow />,
    prevArrow: isMobile && <PrevArrow />,
  };

  return (
    <>
      <Slider {...settings}>
        {APP_SCREENS.map((data) => (
          <div className="carousal">
            {/* <div className="carousal_frame">
              <img src={data.screenImg} alt="" className="carousal_img" />
            </div> */}
            <div>
            <div   className="carousal_img">
              <div style={{margin: "-2px"}}>
              <img src={data?.screenImg} alt=""  />
              </div>
            </div>
            </div>

            <div className="carousal_text">{data.text}</div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default Carousel;
